'use strict';

import {SectionCtrl} from "./sectionctrl.js";

export class SectionA1GeneralCtrl extends SectionCtrl
{
	text = {
		before: {
			key: 'a1_general_before',
			on: false,
			value: null
		},
		after: {
			key: 'a1_general_after',
			on: false,
			value: null
		}
	};
	
	$onInit(){
		if(typeof(this.section.instructions) !== 'undefined'){
			for(let prop in this.text){
				if(typeof(this.section.instructions[this.text[prop].key]) !== 'undefined' && this.section.instructions[this.text[prop].key].value !== ''){
					this.text[prop].on = true;
					this.text[prop].value = this.section.instructions[this.text[prop].key].value;
				}
			}
		}
	}
	
	removeDependentField(){
		let ctrlFldId = null;
		let dstFldId = null;
		for(let fld of this.section.fields){
			if(fld.name=='a1_general_has_previous'){
				if(fld.value == 1){
					break;
				}
				ctrlFldId = fld.id;
			}
			if(fld.name=='a1_general_previous'){
				dstFldId = fld.id;
			}
		}
		if(ctrlFldId && dstFldId){
			this.section.fields = this.$filter('filter')(this.section.fields, {id: '!'+dstFldId}, true);
		}
	}
}

